import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_BASE_URL } from "../../config/api";

export const chatApi = createApi({
    reducerPath: "chatApi",

    baseQuery: fetchBaseQuery({
        baseUrl: API_BASE_URL,
        prepareHeaders: (headers) => {
            const token = localStorage.getItem("token");

            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }

            headers.set("Content-Type", "application/json");
            return headers;
        },
    }),

    tagTypes: ["Chats", "Messages"],

    endpoints: (builder) => ({
        /* ================= CHAT LIST ================= */
        getChatList: builder.query({
            query: () => "/agents/me/messages",
            providesTags: ["Chats"],
        }),

        /* ================= CHAT MESSAGES ================= */
        getChatMessages: builder.query({
            query: (chatId) => `/agents/chats/${chatId}/messages`,
            providesTags: (result, error, chatId) => [
                { type: "Messages", id: chatId },
            ],
        }),

        /* ================= SEND MESSAGE ================= */
        sendMessage: builder.mutation({
            // Keep sendMessage as JSON-based API (payload) for small requests
            query: ({ sender_mobile_number, message }) => ({
                url: `/agents/me/conversations/${sender_mobile_number}/send`,
                method: "POST",
                body: JSON.stringify({ message }),
                headers: {
                    "Content-Type": "application/json",
                    "X-User-UID": "8eab5cc6-88c3-4ccc-a79c-523f13e8f7ad",
                },
            }),
            invalidatesTags: ["whatsApp"],
        }),
        assignchat: builder.mutation({
            query: (payload) => ({  // Accept payload parameter here
                url: `/agents/me/assign-message`,
                method: "POST",
                body: payload,  // Use the payload parameter here
                headers: {
                    "Content-Type": "application/json",
                    "X-User-UID": "8eab5cc6-88c3-4ccc-a79c-523f13e8f7ad",
                },
            }),
            invalidatesTags: ["Chats"],
        }),
        getchatHistory: builder.query({
            query: (sender_mobile_number) => ({
                url: `/agents/me/conversations/${sender_mobile_number}`,
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "X-User-UID": "8eab5cc6-88c3-4ccc-a79c-523f13e8f7ad",
                },
            }),
            providesTags: ["Chats"],
        }),

        getWhatsappChatAgents: builder.query({
            query: () => ({
                url: `/agents/me/online-agents`,
                method: "GET",
                headers: {
                    accept: "application/json",
                    "X-User-UID": "8eab5cc6-88c3-4ccc-a79c-523f13e8f7ad",
                },
            }),
            transformResponse: (response) => response.agents || [],

            providesTags: ["whatsApp"],
        }),

        // --- Typing Indicator ---
        getTypingStatus: builder.query({
            query: (phone) => ({
                url: `/agents/me/conversations/${phone}/typing`,
                method: "GET",
            }),
            pollingInterval: 3000, // auto-refresh every 3 sec
        }),

        sendTypingStatus: builder.mutation({
            query: ({ phone, is_typing }) => ({
                url: `/agents/me/conversations/${phone}/typing`,
                method: "POST",
                body: { is_typing },
            }),
        }),

        // --- Mark Message Read ---
        markMessageRead: builder.mutation({
            query: (messageId) => ({
                url: `/agents/me/messages/${messageId}/mark-read`,
                method: "POST",
            }),
        }),
        agentstatus: builder.mutation({
            query: (payload) => ({
                url: `/agents/me/presence`,
                method: "POST",
                body: payload,
                headers: {
                    "Content-Type": "application/json",
                    "X-User-UID": "8eab5cc6-88c3-4ccc-a79c523f13e8f7ad",
                },
            }),
            invalidatesTags: ["Chats"],
        }),
        chatTransfer: builder.mutation({
            query: ({ sender_mobile_number, target_agent_id }) => ({
                url: `/agents/me/conversations/${sender_mobile_number}/transfer`,
                method: "POST",
                body: {
                    target_agent_id,
                },
                headers: {
                    "Content-Type": "application/json",
                    "X-User-UID": "8eab5cc6-88c3-4ccc-a79c523f13e8f7ad",
                },
            }),
            invalidatesTags: ["Chats"],
        }),
    }),
});


export const {
    useChatTransferMutation,
    useAgentstatusMutation,
    useGetTypingStatusQuery,
    useSendTypingStatusMutation,
    useMarkMessageReadMutation,
    useGetWhatsappChatAgentsQuery,
    useGetchatHistoryQuery,
    useAssignchatMutation,
    useGetChatListQuery,
    useGetChatMessagesQuery,
    useSendMessageMutation,
} = chatApi;
